import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import './App.css';

// Public Pages
import HomePage from './pages/HomePage';
import PricingPage from './pages/PricingPage';
import SamplesPage from './pages/SamplesPage';
import FAQPage from './pages/FAQPage';
import AuditPage from './pages/AuditPage';
import GoogleBusinessPage from './pages/GoogleBusinessPage';
import StartPage from './pages/StartPage';
import PolicyPage from './pages/PolicyPage';

// Service Pages
import ResumeRewritePage from './pages/services/ResumeRewritePage';
import ResumeRefreshPage from './pages/services/ResumeRefreshPage';
import LinkedInOptimizationPage from './pages/services/LinkedInOptimizationPage';
import CoverLetterPage from './pages/services/CoverLetterPage';
import ResumeReviewPage from './pages/services/ResumeReviewPage';

// Niche Pages
import CustomerServicePage from './pages/niche/CustomerServicePage';
import OfficeAdminPage from './pages/niche/OfficeAdminPage';
import CareerChangePage from './pages/niche/CareerChangePage';
import EntryLevelPage from './pages/niche/EntryLevelPage';
import OperationsPage from './pages/niche/OperationsPage';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = `${BACKEND_URL}/api`;

function AppRouter() {
  return (
    <Routes>
      {/* Public Marketing Pages */}
      <Route path="/" element={<HomePage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/samples" element={<SamplesPage />} />
      <Route path="/faq" element={<FAQPage />} />
      <Route path="/audit" element={<AuditPage />} />
      <Route path="/google-business" element={<GoogleBusinessPage />} />
      <Route path="/policies/:policyKey" element={<PolicyPage />} />
      
      {/* Service Pages */}
      <Route path="/services/resume-rewrite" element={<ResumeRewritePage />} />
      <Route path="/services/resume-refresh" element={<ResumeRefreshPage />} />
      <Route path="/services/linkedin-optimization" element={<LinkedInOptimizationPage />} />
      <Route path="/services/cover-letter" element={<CoverLetterPage />} />
      <Route path="/services/resume-review" element={<ResumeReviewPage />} />
      
      {/* Niche Pages */}
      <Route path="/for/customer-service" element={<CustomerServicePage />} />
      <Route path="/for/office-admin" element={<OfficeAdminPage />} />
      <Route path="/for/career-change" element={<CareerChangePage />} />
      <Route path="/for/entry-level" element={<EntryLevelPage />} />
      <Route path="/for/operations" element={<OperationsPage />} />
      
      {/* Intake Form */}
      <Route path="/start" element={<StartPage />} />
      
      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <AppRouter />
    </BrowserRouter>
  );
}

export default App;
